export default {
    data () {
        return {

        }
    },
    methods: {
        postDomain (data, id = '') {
            return this.$http.post(api+'api/v1/app-domains/'+id, data, {emulateJSON:true})
        },
        fetchDomains (app = 0) {
            return this.$http.get(api+'api/v1/app-domains?app='+app, {emulateJSON:true})
        },
        removeDomain (id = 0) {
            return this.$http.delete(api+'api/v1/app-domains/'+id, {emulateJSON:true})
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/appmanager.js